module.exports = __webpack_public_path__ + "static/media/mosfet_board_+_5-min.4a33e135.jpg";